import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import axios from "axios";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Get API base URL at runtime - ALWAYS check window.location first
export function getApiBaseUrl() {
  // Always use same-origin in browser for production domains
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    const origin = window.location.origin;
    
    // List of production domains that should use same-origin API calls
    const productionDomains = [
      'flightcore.cuvano.com',
      '.emergent.host',
      '.cuvano.com'
    ];
    
    // Check if current origin matches any production domain
    for (const domain of productionDomains) {
      if (origin.includes(domain)) {
        return origin;
      }
    }
    
    // For preview environment, also use same-origin if it's an emergentagent preview
    if (origin.includes('preview.emergentagent.com')) {
      return origin;
    }
  }
  
  // Fallback for SSR or unknown environments
  return '';
}

// Create a configured axios instance for API calls
export const api = axios.create();

// Request interceptor to set base URL dynamically at request time
api.interceptors.request.use((config) => {
  const baseUrl = getApiBaseUrl();
  
  // If URL doesn't start with http, prepend the base URL
  if (config.url && !config.url.startsWith('http')) {
    config.url = `${baseUrl}${config.url}`;
  }
  
  // Ensure auth token is included if available
  const token = localStorage.getItem('token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error(`API Error: ${error.response.status} - ${error.config?.url}`);
    } else if (error.request) {
      console.error(`Network Error: ${error.config?.url}`);
    }
    return Promise.reject(error);
  }
);
